import { useNavigate } from "react-router-dom";
import "./BackButton.css";
import { ArrowLeftCircle } from "lucide-react";

const BackButton = ({ to }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (to) {
            navigate(to);
        } else {
            navigate(-1);
        }
    };

    return (
        <button className="back-button" onClick={handleClick}>
            <ArrowLeftCircle size={50} />
        </button>
    );
};

export default BackButton;
